"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Tooltip = _interopRequireDefault(require("./../../Tooltip"));

var _makeStyles = _interopRequireDefault(require("./../../makeStyles"));

var _useTextOverflow2 = _interopRequireDefault(require("../../MasterDetail/internal/useTextOverflow"));

var _tokens = require("./../../styles/tokens");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    root: {
      textOverflow: 'ellipsis',
      width: "calc(100% - " + _tokens.spacing40 + ")",
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      position: 'relative',
      display: 'inline-block'
    },
    required: {
      width: "calc(100% - " + _tokens.spacing60 + ")"
    },
    password: {
      width: 'calc(100% - 2rem)'
    },
    passwordRequired: {
      width: 'calc(100% - 3rem)'
    },
    onlyEndAdornment: {
      width: "calc(100% - 0rem)"
    },
    onlyEndAdornmentRequired: {
      width: "calc(100% - 1rem)"
    },
    labelNoOverflow: {
      display: 'initial'
    }
  };
});

var TextFieldLabel = function TextFieldLabel(props) {
  var _cn;

  var children = props.children,
      required = props.required,
      type = props.type,
      _props$InputProps = props.InputProps;
  _props$InputProps = _props$InputProps === void 0 ? {} : _props$InputProps;
  var startAdornment = _props$InputProps.startAdornment,
      endAdornment = _props$InputProps.endAdornment;
  var classes = useStyles();
  var labelRef = (0, _react.useRef)(null);

  var _useTextOverflow = (0, _useTextOverflow2.default)(labelRef),
      overflow = _useTextOverflow[0];

  var _useState = (0, _react.useState)(''),
      overflowStyle = _useState[0],
      setOverflowStyle = _useState[1];

  (0, _react.useEffect)(function () {
    if (!overflow) {
      setOverflowStyle(classes.labelNoOverflow);
    } else {
      setOverflowStyle('');
    }
  }, [overflow, classes.labelNoOverflow]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, overflow ? /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: children
  }, /*#__PURE__*/_react.default.createElement("span", {
    ref: labelRef,
    className: (0, _classnames.default)(classes.root, (_cn = {}, _cn[classes.password] = type === 'password', _cn[classes.passwordRequired] = type === 'password' && required, _cn[classes.onlyEndAdornment] = !startAdornment && endAdornment && type !== 'password', _cn[classes.onlyEndAdornmentRequired] = !startAdornment && endAdornment && required, _cn[classes.required] = required, _cn))
  }, children)) : /*#__PURE__*/_react.default.createElement("span", {
    ref: labelRef,
    className: (0, _classnames.default)(classes.root, overflowStyle)
  }, children));
};

TextFieldLabel.propTypes = {
  children: _propTypes.default.node,
  type: _propTypes.default.string,
  InputProps: _propTypes.default.object,
  startAdornment: _propTypes.default.node,
  endAdornment: _propTypes.default.node,
  required: _propTypes.default.bool
};
var _default = TextFieldLabel;
exports.default = _default;